import React from 'react';
import { Link } from 'react-router-dom';
import 'assets/styles/List.css';

const Header = () => {
  return (
    <header className="list-header">
      {/* <img src="/assets/images/basic/logo.png" className="App-logo" alt="logo" />
      <nav>
        <ul className="nav-links">
          <li><Link to="/">Login</Link></li>
          <li><Link to="/user">User</Link></li>
          <li><Link to="/invoice">Invoice</Link></li>
          <li><Link to="/role">Role</Link></li>
        </ul>
      </nav> */}
    </header>
  );
};

export default Header;